// ----------------------------------------------------------------------------
// Component: Testimonial
// ----------------------------------------------------------------------------
//
// A list of testimonials
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/keyboard';
import './_testimonial.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--testimonials';
var CAROUSEL_SECTION_SELECTOR = '.carousel-section--testimonials';
var CAROUSEL_SECTION_CLASS = 'carousel-section--testimonials';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
function handleTestimonialSlides(swiper) {
  swiper.slides.forEach(function (slide, index) {
    slide.addEventListener('focus', function () {
      var swiperEl = swiper.el;
      var slidePos = swiperEl.getBoundingClientRect();

      // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
      swiperEl.scrollLeft = 0;
      swiper.slideTo(index);

      // Emulating normal tab focus due to needing to remove standard scroll
      // If element is already in viewport, do nothing
      // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
      if (!(slidePos.top >= 0 && slidePos.left >= 0 && slidePos.bottom <= window.innerHeight && slidePos.right <= window.innerWidth)) {
        window.scrollTo({
          top: slidePos.top + window.scrollY - window.innerHeight / 2,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  });
}
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  var carousel = element.querySelector(CAROUSEL_SELECTOR);
  if (!carousel) return;
  var testimonialCount = parseInt(carousel.getAttribute('data-testimonial-count') || '0', 10);

  // Skip Swiper initialization if only one testimonial (arrows/pagination already hidden in Liquid)
  if (testimonialCount <= 1) {
    return;
  }

  // Generate unique class for each collection list slider
  var uniqueClass = "".concat(CAROUSEL_SELECTOR.replace('.', ''), "-").concat(index);
  carousel.classList.add(uniqueClass);

  // Generate unique btn classes for slider arrows (both mobile and desktop)
  var prevButtons = element.querySelectorAll(CAROUSEL_PREV_BUTTON_SELECTOR);
  var nextButtons = element.querySelectorAll(CAROUSEL_NEXT_BUTTON_SELECTOR);
  var pagination = element.querySelector(CAROUSEL_PAGINATION_SELECTOR);
  prevButtons.forEach(btn => {
    btn.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index));
  });
  nextButtons.forEach(btn => {
    btn.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index));
  });
  if (pagination) {
    pagination.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
  }
  var swiper = new Swiper(".".concat(uniqueClass), {
    modules: [Navigation, Pagination, Keyboard],
    slidesPerView: 1,
    spaceBetween: 24,
    loop: false,
    // Not infinite slider
    observer: true,
    observeParents: true,
    watchOverflow: true,
    breakpoints: {
      // Desktop: show up to 3 cards, each ~14/24 columns wide
      1080: {
        slidesPerView: Math.min(testimonialCount, 3),
        spaceBetween: 24,
        centeredSlides: testimonialCount === 2,
        // Center if only 2 testimonials
        slidesPerGroup: 1
      }
    },
    navigation: {
      nextEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index),
      prevEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index)
    },
    pagination: {
      el: ".".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index),
      type: 'bullets',
      clickable: true
    }
  });
  handleTestimonialSlides(swiper);

  // Sync arrows container height with swiper height for proper centering
  var desktopArrows = element.querySelector('.testimonials__arrows--desktop');
  var mobileArrows = element.querySelector('.testimonials__arrows--mobile');
  var showArrows = () => {
    if (desktopArrows) {
      desktopArrows.classList.add('is-positioned');
    }
    if (mobileArrows) {
      mobileArrows.classList.add('is-positioned');
    }
  };

  // Need to position this via JS because the arrows need to be centered with the slides, not the container
  if (desktopArrows && carousel) {
    var syncArrowHeight = () => {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        var swiperHeight = carousel.offsetHeight;
        if (swiperHeight > 0) {
          desktopArrows.style.height = "".concat(swiperHeight, "px");
          // Show arrows after height is set
          showArrows();
        }
      });
    };

    // Initial sync after a small delay to ensure Swiper has initialized
    setTimeout(syncArrowHeight, 0);
    var resizeObserver = new ResizeObserver(syncArrowHeight);
    resizeObserver.observe(carousel);
    swiper.on('resize', syncArrowHeight);
    swiper.on('slideChange', syncArrowHeight);
  } else {
    // If no desktop arrows, show mobile arrows immediately
    showArrows();
  }
});